/**
 * Extracted from snippets/localization-selector.liquid (inline <script> at line 308).
 * Config bridge: window.__nsLocalizationSelectors, keyed by the localization form's DOM id.
 * This snippet renders up to ten times on a page (header, both footers, the
 * mobile navigation panel, country and locale variants), so the same ~3.7KB
 * of JavaScript was being inlined into the document once per render. Keyed
 * by form id rather than section id because several instances share a section.
 * Boots once per registered form; the original dataset.localeHandlerReady
 * guard is still there and still does its job.
 */

(function () {
  var cfg = window.__nsLocalizationSelectors = window.__nsLocalizationSelectors || {};
  function boot(nsFormId, nsSettings) {
        (() => {
          const form = document.getElementById(`${nsFormId}`);
          const popover = document.getElementById(`${nsSettings.popoverId}`);
          if (!form || form.dataset.localeHandlerReady) return;
          form.dataset.localeHandlerReady = 'true';

          form.addEventListener('submit', (event) => {
            const option = event.submitter;
            if (!option || !option.dataset.countryCode) {
              event.preventDefault();
              return;
            }

            const countryInput = form.querySelector('[name="country_code"]');
            const localeInput = form.querySelector('[name="locale_code"]');

            if (countryInput) {
              countryInput.value = option.dataset.countryCode;
            }

            if (localeInput) {
              localeInput.value = option.dataset.localeCode || '';
            }
          });

          if (!popover || popover.dataset.styleHandlerReady) return;
          popover.dataset.styleHandlerReady = 'true';

          const applyPopoverStyles = () => {
            const shadowRoot = popover.shadowRoot;
            if (!shadowRoot) return;

            const isMobileDrawer = window.matchMedia('screen and (max-width: 999px)').matches;
            const content = shadowRoot.querySelector('[part="content"]');
            const body = shadowRoot.querySelector('[part="body"]');
            const overlay = shadowRoot.querySelector('[part="overlay"]');
            const closeButton = shadowRoot.querySelector('[part="outside-close-button"]');
            const title = shadowRoot.querySelector('[part="title"]');

            if (content) {
              content.style.setProperty('background', '#fff', 'important');
              content.style.setProperty('color', '#000', 'important');
              content.style.setProperty('padding', '0', 'important');

              if (isMobileDrawer) {
                content.style.setProperty('width', '100%', 'important');
                content.style.setProperty('min-width', '0', 'important');
                content.style.setProperty('border', '0', 'important');
                content.style.setProperty('border-radius', '8px 8px 0 0', 'important');
                content.style.setProperty('box-shadow', 'none', 'important');
                content.style.removeProperty('max-height');
              } else {
                content.style.setProperty('border', '1px solid #e2e2e2', 'important');
                content.style.setProperty('border-radius', '2px', 'important');
                content.style.setProperty('box-shadow', '0 2px 8px rgb(0 0 0 / 6%)', 'important');
                content.style.setProperty('width', 'max-content', 'important');
                content.style.setProperty('min-width', '90px', 'important');
                content.style.setProperty('max-height', 'none', 'important');
              }
            }

            if (body) {
              body.style.setProperty('padding', '4px 0', 'important');
              body.style.setProperty('text-align', 'start', 'important');
            }

            if (isMobileDrawer) {
              overlay?.style.removeProperty('display');
              closeButton?.style.removeProperty('display');
              title?.style.removeProperty('display');
              title?.style.setProperty('background', '#fff', 'important');
              title?.style.setProperty('color', '#000', 'important');
            } else {
              overlay?.style.setProperty('display', 'none', 'important');
              closeButton?.style.setProperty('display', 'none', 'important');
              title?.style.setProperty('display', 'none', 'important');
            }
          };

          popover.addEventListener('dialog:after-show', applyPopoverStyles);
          if (popover.hasAttribute('open')) applyPopoverStyles();
        })();
    
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
